<script>
    import InvalidReasonsType from './InvalidReasonsType.svelte';
    export let row = {};
    export let col;
    export let options;
</script>


{#if row.invalid_reasons}
    <InvalidReasonsType
        {row}
        fix = true
    />
  {/if}

